import { cn } from '@/lib/cn'

/** Brand marks copied from uncompromised-store/frontend/public/logos into public/brand. */
export function Logo({
  variant = 'wordmark',
  tone = 'dark',
  className,
}: {
  variant?: 'wordmark' | 'mark'
  tone?: 'dark' | 'light'
  className?: string
}) {
  const src =
    variant === 'wordmark'
      ? `/brand/logo-${tone === 'dark' ? 'dark' : 'white'}.svg`
      : `/brand/icon-${tone === 'dark' ? 'dark' : 'white'}.svg`
  return (
    <img
      src={src}
      alt="Uncompromised"
      className={cn(variant === 'wordmark' ? 'h-5 w-auto' : 'h-8 w-8', 'dark:invert', className)}
    />
  )
}
